<section class="vc-admin-entity-detail">
  <app-admin-page-header
    titleKey="COMMON.CALENDARS"
    descriptionKey="ADMIN.SITES.DETAIL.CALENDARS_DESCRIPTION"
    [showBack]="true"
    [backLink]="backLink"
    contextLabelKey="COMMON.NAME"
    [contextValue]="isEditMode ? (calendar?.name || '') : (site?.name || '')"
  ></app-admin-page-header>

  <div class="vc-admin-entity-detail__content">
    @if (loading) {
      <app-admin-state-panel
        mode="loading"
        titleKey="COMMON.LOADING"
      ></app-admin-state-panel>
    } @else if (hasError || !site) {
      <app-admin-state-panel
        mode="error"
        titleKey="COMMON.ERROR"
        descriptionKey="ADMIN.SITES.DETAIL.ERROR"
        [showRetry]="true"
        (retry)="load()"
      ></app-admin-state-panel>
    } @else {
      <nav class="vc-admin-calendar-detail__tabs">
        <button
          type="button"
          class="vc-admin-calendar-detail__tab"
          [class.is-active]="activeSection === 'details'"
          (click)="setSection('details')"
        >
          {{ 'ADMIN.SITES.CALENDARS.DETAILS.TITLE' | translate }}
        </button>
        <button
          type="button"
          class="vc-admin-calendar-detail__tab"
          [class.is-active]="activeSection === 'schedule'"
          (click)="setSection('schedule')"
        >
          {{ 'ADMIN.SITES.CALENDARS.SCHEDULE.TITLE' | translate }}
        </button>
      </nav>

      @if (activeSection === 'details') {
        <app-admin-form-layout
          titleKey="ADMIN.SITES.CALENDARS.DETAILS.TITLE"
          descriptionKey="ADMIN.SITES.CALENDARS.DETAILS.DESCRIPTION"
        >
          <app-form-calendar
            [affectedSite]="site"
            [payload]="calendar || undefined"
            [allowDelete]="isEditMode"
            [onCreate]="onCreate"
            [onUpdate]="onUpdate"
          ></app-form-calendar>
        </app-admin-form-layout>
      } @else {
        <app-admin-form-layout
          titleKey="ADMIN.SITES.CALENDARS.SCHEDULE.TITLE"
          descriptionKey="ADMIN.SITES.CALENDARS.SCHEDULE.DESCRIPTION"
        >
          <div class="vc-admin-calendar-detail__schedule">
            @for (day of weekDays; track day.id) {
              <section class="vc-admin-calendar-detail__day">
                <header class="vc-admin-calendar-detail__day-header">
                  <h4>{{ day.labelKey | translate }}</h4>
                  <button
                    pButton
                    type="button"
                    class="p-button-text p-button-sm"
                    icon="fas fa-plus"
                    [label]="'ADMIN.SITES.CALENDARS.SCHEDULE.ADD_RANGE' | translate"
                    (click)="addRange(day.id)"
                  ></button>
                </header>

                @if (!getRangesForDay(day.id).length) {
                  <p class="vc-admin-calendar-detail__day-empty">
                    {{ 'ADMIN.SITES.CALENDARS.SCHEDULE.EMPTY_DAY' | translate }}
                  </p>
                } @else {
                  <div class="vc-admin-calendar-detail__ranges">
                    @for (range of getRangesForDay(day.id); track $index; let i = $index) {
                      <div class="vc-admin-calendar-detail__range">
                        <input
                          type="time"
                          class="p-inputtext p-component"
                          [(ngModel)]="range.start"
                          [attr.aria-label]="'ADMIN.SITES.CALENDARS.SCHEDULE.START' | translate"
                        />
                        <span>—</span>
                        <input
                          type="time"
                          class="p-inputtext p-component"
                          [(ngModel)]="range.end"
                          [attr.aria-label]="'ADMIN.SITES.CALENDARS.SCHEDULE.END' | translate"
                        />
                        <button
                          pButton
                          type="button"
                          class="p-button-text p-button-danger p-button-sm"
                          icon="fas fa-trash"
                          (click)="removeRange(day.id, i)"
                        ></button>
                      </div>
                    }
                  </div>
                }

                @if (getDayValidationError(day.id)) {
                  <small class="p-error">
                    {{ getDayValidationError(day.id) | translate }}
                  </small>
                }
              </section>
            }

            <div class="vc-admin-calendar-detail__schedule-actions">
              <button
                pButton
                type="button"
                class="p-button-sm"
                [label]="'COMMON.SAVE' | translate"
                [disabled]="!isEditMode || hasScheduleErrors()"
                (click)="saveScheduleDraft()"
              ></button>
            </div>
          </div>
        </app-admin-form-layout>
      }
    }
  </div>
</section>
